import "./PlumbingServices.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import EmergencyServices from "./sections/EmergencyServices";
import DrainServices from "./sections/DrainServices";
import WaterHeater from "./sections/WaterHeater";
import PlumbingRepair from "./sections/PlumbingRepair";
import Process from "./sections/Process";
import Problems from "./sections/Problems";
import Brands from "./sections/Brands";
import ServiceArea from "./sections/ServiceArea";
import CommercialFaq from "./sections/CommercialFaq";
import RequestService from "./sections/RequestService";
import Footer from "@/reusable_sections/Footer";
export default function PlumbingServicesPage() {
  return <div>
      <Header />
      <Hero />
      <Services />
      <EmergencyServices />
      <DrainServices />
      <WaterHeater />
      <PlumbingRepair />
      <Process />
      <Problems />
      <Brands />
      <ServiceArea />
      <CommercialFaq />
      <RequestService />
      <Footer />
    </div>;
}